
import { Panel } from "primereact/panel";
import { TextField } from "../../../components/TextField";
import { useTranslation } from "react-i18next";
import { formatarCNPJ, formatarCPF } from "../../../utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
 

 
export const DividaAtiva = ({dividaAtiva}: {dividaAtiva: any}) => {
  const { t } = useTranslation();
  const getValue = (value?: string): string => value || "Não informado";
 
  return (
    <div>
      <Panel header={t('dividaAtiva')}>
        {dividaAtiva.message ? (<p>{dividaAtiva.message}</p>):(<div>
        <Panel header="Resumo">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Documento"
                value={getValue(dividaAtiva?.retorno.Resumo.CPF ? formatarCPF(dividaAtiva?.retorno.Resumo.CPF) : formatarCNPJ(dividaAtiva?.retorno.Resumo.CNPJ))}
              />
              <TextField
                label="Quantidade Dívidas"
                value={getValue(dividaAtiva?.retorno.Resumo.QtdDividas)}
              />
              <TextField
                label="Quantidade Dívida SIDA"
                value={dividaAtiva?.retorno.Resumo.QtdDividaSIDA}
              />
              <TextField
                label="Dívida Atual"
                value={dividaAtiva?.retorno.Resumo.DividaMaisAntiga}
              />
              <TextField
                label="Maior Valor Dívida"
                value={dividaAtiva?.retorno.Resumo.ValorMaiorDivida}
              />
              <TextField
                label="Valor Total Dívida"
                value={dividaAtiva?.retorno.Resumo.TotalDivida}
              />
            </div>
            <div>
              <TextField
                label="Nome"
                value={getValue(dividaAtiva?.retorno.Resumo.Nome)}
              />
              <TextField
                label="Quantidade Dívidas FGTS"
                value={
                  dividaAtiva?.retorno.Resumo.QtdDividaFGTS
                }
              />
              <TextField
                label="Quantidade Dívidas Previdenciárias"
                value={dividaAtiva?.retorno.Resumo.QtdDividaPREV}
              />
              <TextField
                label="Dívida mais antiga"
                value={dividaAtiva?.retorno.Resumo.DividaMaisAntiga}
              />
              <TextField
                label="Menor Valor Dívida"
                value={dividaAtiva?.retorno.Resumo.ValorMenorDivida}
              />
            </div>
          </section>
        </Panel>
         <br></br>
         <Panel header="Sistema Integrado Dívida Ativa">     
          <DataTable size="small" value={dividaAtiva.retorno.SIDAList} tableStyle={{ minWidth: '50rem' }}>  
            <Column field="DataInscricao" header={t('data')}></Column>
            <Column field="UF" header={t('uf')}></Column>
            <Column field="TipoSituacaoInscricao" header={t('tipo')}></Column>
            <Column field="ValorConsolidado" header={t('valor')}></Column>
            <Column field="NumeroInscricao" header={t('numero')}></Column>
            <Column field="UnidadeResponsavel" header={t('unidade')}></Column>
            <Column field="TipoDevedor" header={t('tipoDevedor')}></Column>
            <Column field="SituacaoInscricao" header={t('situacao')}></Column>
            <Column field="ReceitaPrincipal" header={t('receita')}></Column>
          </DataTable>
        </Panel>
        <br></br>
        <Panel header="Dívida FGTS">     
          <DataTable size="small" value={dividaAtiva.retorno.FGTSList} tableStyle={{ minWidth: '50rem' }}>  
            <Column field="DataInscricao" header={t('data')}></Column>
            <Column field="UF" header={t('uf')}></Column>
            <Column field="TipoSituacaoInscricao" header={t('tipo')}></Column>
            <Column field="ValorConsolidado" header={t('valor')}></Column>
            <Column field="NumeroInscricao" header={t('numero')}></Column>
            <Column field="EntidadeResponsavel" header={t('entidade')}></Column>
            <Column field="UnidadeResponsavel" header={t('unidade')}></Column>
            <Column field="TipoDevedor" header={t('tipoDevedor')}></Column>
            <Column field="SituacaoInscricao" header={t('situacao')}></Column>
            <Column field="TipoSituacaoInscricao" header={t('tipoSituacao')}></Column>
            <Column field="ReceitaPrincipal" header={t('receita')}></Column>
          </DataTable>
        </Panel>  
        <br></br>
        <Panel header="Dívida Previdenciária">     
          <DataTable size="small" value={dividaAtiva.retorno.PrevidenciaList} tableStyle={{ minWidth: '50rem' }}>
            <Column field="DataInscricao" header={t('data')}></Column>
            <Column field="UF" header={t('uf')}></Column>
            <Column field="TipoSituacaoInscricao" header={t('tipo')}></Column>
            <Column field="ValorConsolidado" header={t('valor')}></Column>
            <Column field="NumeroInscricao" header={t('numero')}></Column>
            <Column field="UnidadeResponsavel" header={t('unidade')}></Column>
            <Column field="TipoDevedor" header={t('tipoDevedor')}></Column>
            <Column field="TipoCredito" header={t('tipoCredito')}></Column>
            <Column field="SituacaoInscricao" header={t('situacao')}></Column>
            <Column field="TipoSituacaoInscricao" header={t('tipoSituacao')}></Column>
            <Column field="ReceitaPrincipal" header={t('receita')}></Column>
          </DataTable>
        </Panel> 
        </div>)} 
      </Panel>
      
    </div>
  );
};